import styles from "./Refund.module.css";
import commonStyles from "./../../Common.module.css";
import React from "react";

function Refund() {
  return (
    <div className={styles["Refund"]}>
            <div className={commonStyles["cateTitle"]}>
                <h1>반품, 환불규정</h1>
            </div>
            <h2>반품/환불 규정 안내</h2>
            <hr />

            <div className={styles["nonScrollBox"]}>
                <h3>단순 변심일 경우</h3>
                <p>
                    상품 수령일로부터 7일 이내 교환/반품이 가능하며 왕복 택배비는 고객 부담입니다.
                    <br />
                    반품 시 제품 및 사은품은 모두 반품해주셔야 하며 상품에 손상이 있는 경우 교환/반품이 어려울 수 있습니다.
                </p>

                <h3>상품 불량/오배송의 경우</h3>
                <p>
                    상품 수령일로부터 7일 이내 교환/반품이 가능하며, 택배비는 펫밀리가 부담합니다.
                    <br />
                    *단, 상품 불량을 입증할 수 있는 사진/동영상 첨부 필수
                </p>

                <h3>반품/환불이 되지 않는 경우</h3>
                <p>
                    포장을 개봉하여 사용하거나 상품의 가치가 훼손된 경우(포장용기 포함)
                    <br />
                    제품 출고 후 일정 기간이 만료된 상품에 대한 반품/환불은 불가능
                </p>

                <h3>교환/환불은 동일 제품 1회에 제한함</h3>
                <p>
                    인터넷 사이버몰 이용 표준 약관 제 15조 환급, 반품 및 교환 규정에 의거하여 구매 후 20일 이내여야만 위 규정을 적용받으실 수 있습니다.
                </p>

                <h3>주문 취소</h3>
                <p>
                    Q&A 게시판에 글을 작성해주시면 처리 도와드리겠습니다.
                    <br />
                    *상품 준비중과 입금전에만 가능합니다.
                </p>
            </div>
        </div>);

}

export default Refund;